export default {
  dropdownLoadingText: 'Chargement...',
  dropdownLoadingError: 'Désolé. Un problème technique est survenu lors de la requête.',
  retryLinkText: 'Veuillez réessayer',
  disabled: 'Désactivé',
  error: 'Erreur',
};
